import React from "react";
import { FaCheck, FaTimes } from "react-icons/all";
import { IconContext } from "react-icons";
import bordstein from "../../assets/bordstein.jpg";
import { RequestPayload } from "../sites/types/RequestPayload";
import { UpdateAtDatabaseService } from "../../services/database/UpdateAtDatabaseService";

/**
 * React Component properties
 */
type Props = {
  // function
  onPressNeedHelp: () => void;
  searchResult: RequestPayload;
  trackingID: string;
};

/**
 * Will be called when the user does not need help
 *
 * @param trackingID
 */
async function setNoHelpNeeded(trackingID: string) {
  await UpdateAtDatabaseService.updateNoHelpNeeded(trackingID);
}

/**
 * Cross Innovation Class 2021
 *
 * Team: Kühne + Nagel
 *
 * Kunden Web App
 *
 * This component is used to explain what a delivery free kerb side means
 *
 * @author Tobias Ramm <winf103614@fh-wedel,de>
 * @version last modification: 29.06.2021
 *
 */
export function DeliveryFreeKerbside(props: Props) {
  return (
    <div style={{ width: "100%" }} className={"free_kerbside_container"}>
      <div className={"free_kerbside_info"}>
        <div
          className={"free_kerbside_info_image"}
          style={{ background: `url(${bordstein})` }}
        />

        <div className={"free_kerbside_info_text_container"}>
          <h2>Was bedeutet eine Lieferung Frei Bordsteinkante?</h2>
          <h4>
            Anders als bei einer Paketlieferung, wird bei einer
            Standardlieferung einer Spedition das Stückgut lediglich bis zur
            Bordsteinkante geliefert.   Dies bedeutet, dass die letzten Meter
            von Bordsteinkante bis in den Wohnraum vom Kunden selbst bewältigt
            werden müssen.
          </h4>
        </div>
      </div>

      {!props.searchResult.bookedHelp && !props.searchResult.noHelpNeeded && (
        <div>
          <h3>Können Sie Ihr Stückgut ohne Hilfe annehmen?</h3>
          <div className={"accept_delivery_container"}>
            <div
              className={"accept_delivery_no_help"}
              onClick={async () => setNoHelpNeeded(props.trackingID)}
            >
              <IconContext.Provider
                value={{ color: "#6BC963", className: "icon" }}
              >
                <FaCheck />
              </IconContext.Provider>

              <p>
                <b>Ja,</b> ich benötige keine Hilfe und kann das Stückgut vom
                Abstellort selber bewegen.
              </p>
            </div>

            <div
              className={"accept_delivery_need_help"}
              onClick={() => props.onPressNeedHelp()}
            >
              <IconContext.Provider
                value={{ color: "#E14040", className: "icon" }}
              >
                <FaTimes />
              </IconContext.Provider>

              <p>
                <b>Nein,</b> ich benötige Hilfe, da ich das Stückgut vom
                Abstellort selber nicht bewegen kann.
              </p>
            </div>
          </div>
        </div>
      )}

      {!!props.searchResult.bookedHelp && !props.searchResult.noHelpNeeded && (
        <div>
          <h3>Sie haben folgende Hilfe dazu gebucht:</h3>

          <div className={"picked_choice_container"}>
            <div className={"picked_choice_singleChoice active_choice"}>
              <div className={"checked_icon_container active_choice"}>
                <IconContext.Provider
                  value={{ color: "#6BC963", className: "icon" }}
                >
                  <FaCheck />
                </IconContext.Provider>
              </div>

              <h3>Hilfe durch Fahrer</h3>

              <p>
                Der Fahrer kann bei Sperrgütern bis zu 100 kg bei der Annahme
                helfen.
              </p>

              <h5>Aufpreis: 35€</h5>
            </div>

            <div className={"button_container"}>
              <button onClick={() => props.onPressNeedHelp()}>Ändern</button>
            </div>
          </div>
        </div>
      )}

      {!!props.searchResult.noHelpNeeded && !props.searchResult.bookedHelp && (
        <div>
          <div className={"picked_choice_container"}>
            <div className={"picked_choice_singleChoice active_choice"}>
              <div className={"checked_icon_container active_choice"}>
                <IconContext.Provider
                  value={{ color: "#6BC963", className: "icon" }}
                >
                  <FaCheck />
                </IconContext.Provider>
              </div>

              <h3>Keine Hilfe benötigt</h3>
            </div>

            <div className={"button_container"}>
              <button onClick={() => props.onPressNeedHelp()}>Ändern</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
